'use strict';

const AnnouncementCategory = require('feedback/domain/value/announcement-category');
const Announcement = require('feedback/domain/entity/announcement');
const ReleaseNote = require('feedback/domain/entity/release-note');

class Factory {
    build(json) {
        let category = {};
        if(json && json.categoryName) {
            category = new AnnouncementCategory(json.categoryName);
        } else {
            // category の指定がない場合、Announcement を返す
            return new Promise((resolve) => {
                resolve(new Announcement());
            });
        }

        if(category.isAnnouncement()) {
            return new Promise((resolve) => {
                resolve(new Announcement(json));
            });
        }

        if(category.isReleaseNote()) {
            return new Promise((resolve) => {
                resolve(new ReleaseNote(json));
            });
        }
    }
}

module.exports = Factory;



// WEBPACK FOOTER //
// ./feedback/domain/factory/announcement/index.js